import React, { useState, useContext, useEffect } from "react";
import { useParams } from "react-router-dom";

import { motion, AnimatePresence } from "framer-motion";
import _ from "lodash";
import axios from "axios";

import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

import FormControl from "@mui/material/FormControl";
import Select, { SelectChangeEvent } from "@mui/material/Select";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";

//HOOKS
import useControls from "../../hooks/useControls";

export default function PlayerSelect({
   allPlayers,
   selected,
   column,
   slot,
   callback,
}) {
   const handleChange = (e) => {
      if (e.target.value) {
         callback(column, slot, e.target.value);
      }
   };

   return (
      <>
         {allPlayers && (
            <FormControl fullWidth>
               <InputLabel id={"playerSelect"}>Player</InputLabel>
               <Select
                  value={selected ? selected : 0}
                  label={"Player"}
                  onChange={handleChange}
               >
                  <MenuItem value='0'>Select a Player</MenuItem>
                  {allPlayers.map((player) => (
                     <MenuItem key={player.PlayerId} value={player.PlayerId}>
                        {player.PlayerNameLastFirst}{" "}
                        {player.Rank && <>({player.Rank})</>}
                     </MenuItem>
                  ))}
               </Select>
            </FormControl>
         )}
      </>
   );
}
